export const GET_APP_EMAIL_TEMPLATE_LIST="GET_APP_EMAIL_TEMPLATE_LIST";
export const ADD_APP_EMAIL_TEMPLATE="ADD_APP_EMAIL_TEMPLATE";
export const UPDATE_APP_EMAIL_TEMPLATE="UPDATE_APP_EMAIL_TEMPLATE";
export const DELETE_APP_EMAIL_TEMPLATE="DELETE_APP_EMAIL_TEMPLATE";
export const HIDE_LOADING="HIDE_LOADING";
export const SHOW_LOADING="SHOW_LOADING";
export const APP_EMAIL_TEMPLATE_LIST="APP_EMAIL_TEMPLATE_LIST";
export const SET_ADD_EDIT="SET_ADD_EDIT";
export const GET_APP_INSTANCE_EMAIL_TEMPLATE_LIST="GET_APP_INSTANCE_EMAIL_TEMPLATE_LIST";
export const APP_INSTANCE_EMAIL_TEMPLATE_LIST="APP_INSTANCE_EMAIL_TEMPLATE_LIST";
export const ADD_APP_INSTANCE_EMAIL_TEMPLATE="ADD_APP_INSTANCE_EMAIL_TEMPLATE";
export const UPDATE_APP_INSTANCE_EMAIL_TEMPLATE="UPDATE_APP_INSTANCE_EMAIL_TEMPLATE";
export const DELETE_APP_INSTANCE_EMAIL_TEMPLATE="DELETE_APP_INSTANCE_EMAIL_TEMPLATE";
export const EMAIL_TEMPLATE_MESSAGE="EMAIL_TEMPLATE_MESSAGE";